import { render, staticRenderFns } from "./MyScriptList.vue?vue&type=template&id=c0a2b864&scoped=true&"
import script from "./MyScriptList.vue?vue&type=script&lang=js&"
export * from "./MyScriptList.vue?vue&type=script&lang=js&"
import style0 from "./MyScriptList.vue?vue&type=style&index=0&id=c0a2b864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a2b864",
  null
  
)

export default component.exports